module.exports = __webpack_public_path__ + "img/usdt.3f1a2995.png";